var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketInstructionTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 120,
    viewBox: "0 0 144 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3248_5099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 120H4V119H3V118H2V117H1V116H0V52H1V51H2V50H3V49H4V48H140V49H141V50H142V51H143V52H144V116H143V117H142V118H141V119H140V120Z",
    fill: "#26261E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 48.5V49.5H140.5V50.5H141.5V51.5H142.5V52.5H143.5V115.5H142.5V116.5H141.5V117.5H140.5V118.5H139.5V119.5H4.5V118.5H3.5V117.5H2.5V116.5H1.5V115.5H0.5V52.5H1.5V51.5H2.5V50.5H3.5V49.5H4.5V48.5H139.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 72V71H9V70H8V58H9V57H10V56H22V57H23V58H24V70H23V71H22V72H10Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 56.5V57.5H22.5V58.5H23.5V69.5H22.5V70.5H21.5V71.5H10.5V70.5H9.5V69.5H8.5V58.5H9.5V57.5H10.5V56.5H21.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 72H69V71H68V70H67V69H66V59H67V58H68V57H69V56H95V57H96V58H97V59H98V69H97V70H96V71H95V72Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 56.5V57.5H95.5V58.5H96.5V59.5H97.5V68.5H96.5V69.5H95.5V70.5H94.5V71.5H69.5V70.5H68.5V69.5H67.5V68.5H66.5V59.5H67.5V58.5H68.5V57.5H69.5V56.5H94.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 56.5V57.5H133.5V58.5H134.5V59.5H135.5V68.5H134.5V69.5H133.5V70.5H132.5V71.5H107.5V70.5H106.5V69.5H105.5V68.5H104.5V59.5H105.5V58.5H106.5V57.5H107.5V56.5H132.5Z",
    fill: "#1E1E22",
    stroke: "#FCFF62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 92H10V91H9V90H8V82H9V81H10V80H134V81H135V82H136V90H135V91H134V92Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 80.5V81.5H134.5V82.5H135.5V89.5H134.5V90.5H133.5V91.5H10.5V90.5H9.5V89.5H8.5V82.5H9.5V81.5H10.5V80.5H133.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 112H10V111H9V110H8V102H9V101H10V100H134V101H135V102H136V110H135V111H134V112Z",
    fill: "#6A685C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5 100.5V101.5H134.5V102.5H135.5V109.5H134.5V110.5H133.5V111.5H10.5V110.5H9.5V109.5H8.5V102.5H9.5V101.5H10.5V100.5H133.5Z",
    stroke: "#FAFAE8",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 64L120 36",
    stroke: "#FCFF62",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 38L120.02 34L123 38",
    stroke: "#FCFF62",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 0V2H130V4H132V6H134V22H132V24H130V26H128V28H112V26H110V24H108V22H106V6H108V4H110V2H112V0H128Z",
    fill: "#EAEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 7V9H123V10H124V12H122V11H121V10H119V11H118V12H119V13H121V14H123V15H124V18H123V19H121V21H119V19H117V18H116V16H118V17H119V18H121V17H122V16H121V15H119V14H117V13H116V10H117V9H119V7H121Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 5H126V6H127V7H128V8H129V9H130V10H131V14V18H130V19H129V20H128V21H127V22H126V23H125V24H123V22H124V21H125V20H126V19H127V18H128V17H129V16V12V11H128V10H127V9H126V8H125V7H124V6H123V4H125V5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 5H114V6H113V7H112V8H111V9H110V10H109V14V18H110V19H111V20H112V21H113V22H114V23H115V24H117V22H116V21H115V20H114V19H113V18H112V17H111V16V12V11H112V10H113V9H114V8H115V7H116V6H117V4H115V5Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_5099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketInstructionTwo);
export default __webpack_public_path__ + "static/media/MarketInstructionTwo.2fb5f758f47754e0432a59125f1bb34a.svg";
export { ForwardRef as ReactComponent };